// extracted by mini-css-extract-plugin
module.exports = {"contentStyle":"style_contentStyle__YhDjS"};